import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import moment from 'moment';
import { PnmacPageBubble, PnmacTable, PnmacRow, PnmacMediaQuery, PnmacTitle, PnmacMeta, PnmacText, PnmacHtmlToNative, PnmacUIButton, PnmacNavigation, PnmacCard, PnmacModal, PnmacParagraph, PnmacToolTip } from 'pnmac-universal-components';
import FadeLoader from "../Spinners/FadeSpinner/FadeSpinner";
import Transaction from '../components/Transaction.js';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { currencyFormatter, paymentsource, accountype, paystatus, getPayStatusTranslations, windowObject, encryptBankAccountNumber } from '../utils.js';
import { View, Text, Platform } from 'react-native';
import styles from '../styles/styles.js';
import PendingPayments from '../components/PendingPayment.js';
import { PAYMENT_VALIDATION } from "../redux/actions/actions.js";
import { SuccessMessage } from '../components/SuccessMessage.js';
import PnmacActivityIndicator from '../PnmacActivityIndicator';
import Adbuttler from '../Adbuttler/Adbuttler';
import BannerView from '../v2/BannerView';
import { textStyle } from "../v2/theme";
import withPnmacTitle from '../withPnmacTitle';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../redux/events/events';
var PaymentPending = /** @class */function (_super) {
  __extends(PaymentPending, _super);
  function PaymentPending(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      openCancel: "",
      openEdit: "",
      openCancelAch: false,
      futurePrPayments: [],
      paymentDeleted: null,
      loading: false,
      editAch: false,
      achPayment: {
        bankAccount: {}
      },
      deletedPayment: [],
      showSuccess: true
    };
    return _this;
  }
  PaymentPending.prototype.render = function () {
    var _this = this;
    var _a, _b, _c;
    var _d = this.props,
      translations = _d.translations,
      layout = _d.layout;
    var _e = this.state,
      openCancel = _e.openCancel,
      openCancelAch = _e.openCancelAch,
      showSuccess = _e.showSuccess;
    var paymentInfo = layout.paymentInfo;
    var history = ((_a = layout.currentLoanActivity) === null || _a === void 0 ? void 0 : _a.history) || [];
    var achExist = (_c = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) === null || _c === void 0 ? void 0 : _c.find(function (s) {
      return s.paymentType == 201309;
    });
    history.sort(function (a, i) {
      return moment(i.effectiveDate) - moment(a.effectiveDate);
    });
    var tableHeadListHeloc = [/*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.EffectiveDate)), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.ShortDescription)), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.TransactionAmountColumn)), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.PrincipalColumn, "/", "\n", translations.balance)), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.Interest)), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.Escrow, "/", "\n", translations.balance)), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, styles.oneTimePayment.tableHeader), {
        padding: 0,
        paddingRight: 10
      })
    }, translations.SuspenseAmount, "/", "\n", translations.balance))];
    var english = (layout === null || layout === void 0 ? void 0 : layout.language) == "en";
    var tableDataListHeloc = history.slice(0, 2).map(function (s, i) {
      return [/*#__PURE__*/React.createElement(View, {
        id: "selectedindex".concat(i),
        style: {
          overflowWrap: "break-word",
          whiteSpace: "pre-line",
          cursor: "pointer",
          color: "#003087",
          fontSize: 12
        },
        onClick: function () {
          return _this.setState({
            breakDownOpen: true,
            selectedIndex: history.findIndex(function (e) {
              return e == s;
            })
          });
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, moment(s.effectiveDate).format("MM/DD/YYYY"))), english ? s.transactionCodeDesc : s.spanishTransactionCodeDesc, s.transactionAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.transactionAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.transactionAmount), s.principalAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.principalAmount)), ")\n").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.principalBalance))) : "".concat(currencyFormatter('en-US', 'currency', 'USD', s.principalAmount), "\n").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.principalBalance))), s.interestAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.interestAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.interestAmount), s.escrowAmount < 0 && s.escrowBalance < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowAmount)), ")\n(").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowBalance)), ")") : s.escrowAmount < 0 && s.escrowBalance >= 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowAmount)), ")\n").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowBalance))) : s.escrowAmount >= 0 && s.escrowBalance < 0 ? "".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowAmount)), "\n(").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowBalance)), ")") : "".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowAmount)), "\n").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowBalance))), s.suspenseAmount < 0 && s.suspenseBalanceAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseAmount)), ")\n(").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseBalanceAmount)), ")") : s.suspenseAmount >= 0 && s.suspenseBalanceAmount < 0 ? "".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseAmount)), "\n(").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseBalanceAmount)), ")") : s.suspenseAmount < 0 && s.suspenseBalanceAmount >= 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseAmount)), ")\n").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseBalanceAmount))) : "".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseAmount)), "\n").concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseBalanceAmount)))];
    });
    var lookBack = history.slice(0, 2);
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        xSmall: "(max-width: 300px)",
        small: "(max-width: 599px)",
        iPad: "(max-width: 1023px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        style: {
          paddingHorizontal: 10,
          paddingBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacModal, {
        open: openCancelAch,
        onClose: function () {
          return _this.setState({
            openCancelAch: false
          });
        },
        "aria-label": "payments breakdown"
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 10,
          padding: 20,
          width: matches.small ? '80%' : 500,
          backgroundColor: "#f5f5f5",
          height: "auto"
        }
      }, /*#__PURE__*/React.createElement(PnmacTitle, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          color: "#006B95"
        })
      }, "Cancel Service Edited"), /*#__PURE__*/React.createElement(PnmacTitle, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          color: "#006B95"
        })
      }, translations.CancelServiceMessageLine1), /*#__PURE__*/React.createElement(PnmacTitle, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          color: "#006B95"
        })
      }, translations.CancelServiceMessageLine2), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        idTag7: 'lblACHAlertModalNo',
        nativeID: "btnACHAlertModalNo",
        style: {
          width: '40%'
        },
        mode: "contained",
        onPress: function () {
          return _this.setState({
            openCancelAch: false
          });
        }
      }, translations.ACHAlertModalNo), /*#__PURE__*/React.createElement(PnmacUIButton, {
        idTag7: 'lblACHAlertModalYesCancelMyService',
        loading: _this.state.loading,
        nativeID: "btnACHAlertModalYesCancelMyService",
        style: {
          width: '40%'
        },
        mode: "outlined",
        onPress: function () {
          var _a;
          _this.setState({
            loading: true
          });
          fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(parseInt((_a = _this.state.achPayment) === null || _a === void 0 ? void 0 : _a.draftSource) == 4 ? "delete_ach" : "delete_payment"), {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(_this.props.layout.token),
              "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
            },
            body: JSON.stringify(__assign(__assign({}, _this.state.achPayment), {
              bankAccount: __assign(__assign({}, _this.state.achPayment.bankAccount), {
                unmaskedAccountNumber: undefined,
                confirmAccountNumber: undefined,
                confirmAccountNumberEncode: encryptBankAccountNumber(_this.state.achPayment.bankAccount.confirmAccountNumber)
              }),
              loan: layout.currentLoan
            }))
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            var _a, _b, _c;
            if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
              var newPaymentModel = __assign({}, layout.paymentModel);
              var p = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments.findIndex(function (s) {
                return s.achConfigurationKey == _this.state.achPayment.achConfigurationKey;
              });
              newPaymentModel.pendingPayments.splice(p, 1);
              _this.props.dispatch({
                type: PAYMENT_VALIDATION,
                payment: newPaymentModel
              });
              if (!layout.mobile) {
                if (parseInt((_c = _this.state.achPayment) === null || _c === void 0 ? void 0 : _c.draftSource) == 4) {
                  windowObject.dataLayer = windowObject.dataLayer || [];
                  dataLayer.push({
                    event: 'ach_canceled'
                  });
                }
              }
            }
            _this.setState({
              loading: false
            });
          });
        }
      }, translations.ACHAlertModalYesCancelMyService)))), /*#__PURE__*/React.createElement(PnmacModal, {
        open: openCancel != "",
        onClose: function () {
          return _this.setState({
            openCancel: ""
          });
        },
        "aria-label": "payments breakdown"
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          alignSelf: "center",
          borderRadius: 10,
          padding: 20,
          width: matches.small ? '85%' : 500,
          backgroundColor: "#f5f5f5",
          height: "auto"
        }
      }, /*#__PURE__*/React.createElement(PnmacTitle, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          color: "#006B95"
        })
      }, translations.Attention), ((_b = (_a = _this.state) === null || _a === void 0 ? void 0 : _a.futurePrPayments) === null || _b === void 0 ? void 0 : _b.length) > 0 ? /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.CancelPrincipalReduction, " ", moment((_c = _this.state) === null || _c === void 0 ? void 0 : _c.futurePrPayments[0].effectiveDate).format("MM/DD/YYYY")) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.CancellingSchedule), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: matches.small ? 'column' : "row",
          justifyContent: "space-around",
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        idTag7: 'lblNeverMind',
        nativeID: "btnNeverMind",
        style: {
          flex: Platform.OS === 'web' ? 1 : undefined,
          marginRight: matches.small ? 0 : 20,
          marginBottom: matches.small ? 10 : 0
        },
        mode: "outlined",
        onPress: function () {
          return _this.setState({
            openCancel: ""
          });
        }
      }, translations.NeverMind), /*#__PURE__*/React.createElement(PnmacUIButton, {
        idTag7: 'lblCancelIt',
        loading: _this.state.loading,
        nativeID: "btnCancelIt",
        style: {
          flex: Platform.OS === 'web' ? 1 : undefined
        },
        mode: "contained",
        onPress: function () {
          var _a, _b;
          _this.setState({
            loading: true
          });
          if ((_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments.find(function (s) {
            return s.achConfigurationKey == openCancel;
          })) {
            var cpayment = (_this.state.futurePrPayments || []).concat([(_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments.find(function (s) {
              return s.achConfigurationKey == openCancel;
            })]);
            cpayment.forEach(function (d) {
              d.mobile = layout.mobile;
            });
            cpayment.forEach(function (singlepayments) {
              fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(parseInt(singlepayments === null || singlepayments === void 0 ? void 0 : singlepayments.draftSource) == 4 ? "delete_ach" : "delete_payment"), {
                method: 'POST',
                headers: {
                  "Content-Type": "application/json; charset=utf-8",
                  "Authorization": "Bearer ".concat(_this.props.layout.token),
                  "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
                },
                body: JSON.stringify(__assign(__assign({}, singlepayments), {
                  bankAccount: __assign(__assign({}, singlepayments.bankAccount), {
                    unmaskedAccountNumber: undefined,
                    confirmAccountNumber: undefined,
                    confirmAccountNumberEncode: encryptBankAccountNumber(singlepayments.bankAccount.confirmAccountNumber)
                  }),
                  loan: layout.currentLoan
                }))
              }).then(function (res) {
                return res.json();
              }).then(function (data) {
                var _a, _b;
                if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
                  var newPaymentModel = __assign({}, layout.paymentModel);
                  var p = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments.findIndex(function (s) {
                    return s.serviceRequestID == singlepayments.serviceRequestID;
                  });
                  newPaymentModel.pendingPayments.splice(p, 1);
                  _this.props.dispatch({
                    type: PAYMENT_VALIDATION,
                    payment: newPaymentModel
                  });
                  _this.setState({
                    paymentDeleted: moment(singlepayments.effectiveDate).format("MM/DD/YYYY")
                  });
                  if (!layout.mobile) {
                    if (parseInt(singlepayments === null || singlepayments === void 0 ? void 0 : singlepayments.draftSource) == 4) {
                      windowObject.dataLayer = windowObject.dataLayer || [];
                      dataLayer.push({
                        event: 'ach_canceled'
                      });
                    }
                  }
                }
                _this.setState({
                  openCancel: "",
                  loading: false
                });
              });
            });
          }
        }
      }, translations.CancelIt)))), /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.PendingPaymentPageTitle
      }), !achExist ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations === null || translations === void 0 ? void 0 : translations.SignUpForAutoPayToday,
        onClick: function (e) {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "VPP-page/AutoPay link|Web", 0);
        },
        navigation: {
          navigate: function () {
            var _a;
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "VPP-page/AutoPay link|Mobile", -1, "", false);
            (_a = _this.props) === null || _a === void 0 ? void 0 : _a.navigation.navigate('PaymentsBTN', {
              screen: 'PaymentsBTN',
              initial: false
            });
          }
        }
      }))) : null, ((_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.helocFlag) ?
      /*#__PURE__*/
      // is there a helocflag ? if yes, show heloc verbiage, if no, we go to the payment model
      React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, {
        idTags: 'lblHelocVerbiage'
      }, translations.HelocVerbiage)) : ((_e = layout.paymentModel) === null || _e === void 0 ? void 0 : _e.pendingPayments.length) > 0 ? matches.small ? /*#__PURE__*/React.createElement(React.Fragment, null, _this.state.paymentDeleted && !((_f = layout.paymentModel) === null || _f === void 0 ? void 0 : _f.pendingPayments.find(function (s) {
        return moment(s.effectiveDate).format("MM/DD/YYYY") == moment(_this.state.paymentDeleted).format("MM/DD/YYYY");
      })) ?
      // if payment deleted date && there is no paymentDeleted date in state that matches an effective date, then we show the success message. if not, then this does not show up. the spinner needs to show
      // when modal button is clicked, but successmessage has not yet shown up.
      //matches.small mode here
      showSuccess && /*#__PURE__*/React.createElement(SuccessMessage, {
        onPress: function () {
          return _this.setState({
            showSuccess: false
          });
        },
        message: (_g = translations.PaymentCancelled) === null || _g === void 0 ? void 0 : _g.replace("{0:M/d/yyyy}", _this.state.paymentDeleted)
      }) : null, /*#__PURE__*/React.createElement(PendingPayments, {
        editPress: function (d) {
          if (parseInt(d.paymentType) == 201309) {
            PnmacNavigation(__assign({
              action: {
                pathname: '/Payment/Ach',
                state: {
                  payment: d
                }
              },
              wind: false
            }, _this.props));
          } else {
            PnmacNavigation(__assign({
              action: {
                pathname: '/Payment',
                state: {
                  payment: d,
                  edit: true
                }
              },
              wind: false
            }, _this.props));
          }
        },
        cancelPress: function (d) {
          var _a;
          var printhefuture = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments.filter(function (s) {
            return s.paymentType == 201297 && moment(s.effectiveDate) > moment(d.effectiveDate);
          });
          _this.setState({
            openCancel: d.achConfigurationKey,
            futurePrPayments: printhefuture
          });
        },
        pendingPayments: (_h = layout.paymentModel) === null || _h === void 0 ? void 0 : _h.pendingPayments
      })) : /*#__PURE__*/React.createElement(View, null, " ", _this.state.paymentDeleted && !((_j = layout.paymentModel) === null || _j === void 0 ? void 0 : _j.pendingPayments.find(function (s) {
        return moment(s.effectiveDate).format("MM/DD/YYYY") == moment(_this.state.paymentDeleted).format("MM/DD/YYYY");
      })) ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            showSuccess: false
          });
        },
        message: (_k = translations.PaymentCancelled) === null || _k === void 0 ? void 0 : _k.replace("{0:M/d/yyyy}", _this.state.paymentDeleted)
      }) : null, /*#__PURE__*/React.createElement(PnmacTable, {
        style: {
          marginBottom: 20,
          backgroundColor: "#FFF",
          borderRadius: 10,
          shadowColor: "rgba(0,0,0, .08)",
          shadowOffset: {
            height: 4,
            width: 2
          },
          shadowOpacity: 1,
          shadowRadius: 12
        },
        borderStyle: {
          borderColor: "#EFEFEF"
        }
      }, /*#__PURE__*/React.createElement(PnmacRow, {
        noBorder: true,
        flexArr: [1, 1, 1, 1, 1, 1, 1, 1],
        data: [/*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderSource), /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderAmount), /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderBankAccountType), /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderBankAccount), /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderEffectiveDate), /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderPaymentConfirmationCode), /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign({
            padding: matches.small ? 5 : 0,
            paddingRight: matches.small ? 5 : 10
          }, textStyle.defaultTextTitle)
        }, translations.PendingPaymentHeaderStatus), ""],
        style: {
          padding: matches.small ? 0 : 10,
          paddingLeft: matches.small ? 5 : 10,
          backgroundColor: "#EFEFEF",
          height: "auto",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10
        },
        textStyle: {
          padding: matches.small ? 5 : 0,
          paddingRight: matches.small ? 5 : 10,
          fontSize: matches.small ? 10 : 14
        }
      }), (_m = (_l = layout.paymentModel) === null || _l === void 0 ? void 0 : _l.pendingPayments) === null || _m === void 0 ? void 0 : _m.map(function (d, i) {
        var _a, _b, _c, _d;
        var customers = paymentsource[d.draftSource] == "Web" || paymentsource[d.draftSource] == "Mobile";
        var achdraft = parseInt(d.draftSource) == 4;
        return /*#__PURE__*/React.createElement(PnmacRow, {
          noBorder: true,
          key: i,
          flexArr: [1, 1, 1, 1, 1, 1, 1, 1],
          data: [paymentsource[d.draftSource], currencyFormatter('en-US', 'currency', 'USD', d.totalDraftAmount), accountype[d.bankAccountType], d.bankAccountNumber, moment(d.effectiveDate).format("MM/DD/YYYY"), d.displayedConfirmationId, parseInt(d.status) == 201295 || parseInt(d.status) == 301296 ? /*#__PURE__*/React.createElement(View, null, parseInt(d.status) == 201295 ? /*#__PURE__*/React.createElement(PnmacToolTip, {
            swap: true,
            style: {
              color: "#003087"
            },
            text: getPayStatusTranslations(translations, d.status),
            title: translations.NachaFailedPaymentTooltipMessage
          }) : /*#__PURE__*/React.createElement(PnmacToolTip, {
            swap: true,
            style: {
              color: "#003087"
            },
            text: getPayStatusTranslations(translations, d.status),
            title: translations.NachaPendingPaymentTooltipMessage
          })) : getPayStatusTranslations(translations, d.status), achdraft ? parseInt(d.status) == 0 ? /*#__PURE__*/React.createElement(PnmacUIButton, {
            nativeID: "btnViewDetails",
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              cursor: "none"
            },
            mode: "text",
            contentStyle: {
              cursor: "default"
            },
            loading: true
          }) : /*#__PURE__*/React.createElement(PnmacText, {
            idTag1: 'lblViewDetails',
            onClick: function () {
              PnmacNavigation(__assign({
                action: {
                  pathname: '/Payment/Ach',
                  state: {
                    payment: d
                  }
                },
                wind: false
              }, _this.props));
            },
            style: __assign({
              alignSelf: "center",
              cursor: 'pointer'
            }, textStyle.clickableLink)
          }, translations.ViewDetailsLinkText) : d.canCancel || d.canEdit ? /*#__PURE__*/React.createElement(View, {
            style: {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: "center"
            }
          }, customers && d.canEdit && /*#__PURE__*/React.createElement(PnmacText, {
            idTag1: 'lblEdit',
            onClick: function () {
              if (parseInt(d.paymentType) == 201309) {
                PnmacNavigation(__assign({
                  action: {
                    pathname: '/Payment/Ach',
                    state: {
                      payment: d,
                      edit: true
                    }
                  },
                  wind: false
                }, _this.props));
              } else {
                PnmacNavigation(__assign({
                  action: {
                    pathname: '/Payment',
                    state: {
                      payment: d,
                      edit: true
                    }
                  },
                  wind: false
                }, _this.props));
              }
            },
            style: __assign(__assign({}, textStyle.clickableLink), {
              cursor: 'pointer'
            })
          }, translations.EditLinkText), customers && d.canEdit && /*#__PURE__*/React.createElement(PnmacText, {
            onClick: function () {
              var _a;
              var printhefuture = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments.filter(function (s) {
                return s.paymentType == 201297 && moment(s.effectiveDate) > moment(d.effectiveDate);
              });
              _this.setState({
                openCancel: d.achConfigurationKey,
                futurePrPayments: printhefuture
              });
            },
            style: __assign(__assign({}, textStyle.clickableLink), {
              marginLeft: 2,
              marginRight: 2
            })
          }, "|"), d.canCancel && /*#__PURE__*/React.createElement(PnmacText, {
            idTag1: 'lblCancel',
            onClick: function () {
              var _a;
              if (!layout.pennyWise) {
                var printhefuture = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments.filter(function (s) {
                  return s.paymentType == 201297 && moment(s.effectiveDate) > moment(d.effectiveDate);
                });
                _this.setState({
                  openCancel: d.achConfigurationKey,
                  futurePrPayments: printhefuture
                });
              }
            },
            style: __assign(__assign({}, textStyle.clickableLink), {
              cursor: layout.pennyWise ? 'none' : 'pointer',
              opacity: layout.pennyWise ? 0.6 : 1.0
            })
          }, translations.CancelText)) : parseInt(d.status) == 0 ? /*#__PURE__*/React.createElement(PnmacUIButton, {
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              cursor: "none"
            },
            mode: "text",
            contentStyle: {
              cursor: "default"
            },
            loading: true
          }) : null],
          style: {
            padding: matches.small ? 0 : 10,
            paddingLeft: matches.small ? 5 : 10,
            backgroundColor: i % 2 === 0 ? "#FFF" : "#EFEFEF",
            borderBottomLeftRadius: i === ((_b = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments) === null || _b === void 0 ? void 0 : _b.length) - 1 ? 10 : 0,
            borderBottomRightRadius: i === ((_d = (_c = layout.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) === null || _d === void 0 ? void 0 : _d.length) - 1 ? 10 : 0
          },
          textStyle: {
            padding: matches.small ? 5 : 0,
            fontSize: matches.small ? 10 : 14
          }
        });
      }))) : paymentInfo ? /*#__PURE__*/React.createElement(React.Fragment, null, _this.state.paymentDeleted ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            showSuccess: null
          });
        },
        message: (_o = translations.PaymentCancelled) === null || _o === void 0 ? void 0 : _o.replace("{0:M/d/yyyy}", _this.state.paymentDeleted)
      }) : null, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 5,
          marginBottom: 5
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, {
        idTag1: 'lblNopendingPayments'
      }, "You do not currently have any pending payments.")))
      // TODO change this and change another occurrance below
      :
      /*#__PURE__*/
      //is this.state.paymentDeleted null ? if yes, show the fadeloader. if no, show the successmsg. --> i delete a payment --> this.state.paymentDeleted is nonnull --> i get successmsg. i click successmsg --> this.state.paymentDeleted = null --> fadeloader
      //successmessage should not turn paymentDeleted null. needs its own state.
      React.createElement(View, null, !_this.state.paymentDeleted ? _this.props.layout.mobile ? /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 30,
          marginBottom: 50,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacActivityIndicator, null)) : /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 50,
          marginBottom: 50,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(FadeLoader, {
        size: 200,
        color: "#003187",
        loading: true
      })) : /*#__PURE__*/React.createElement(View, null, _this.state.paymentDeleted ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onPress: function () {
          return _this.setState({
            showSuccess: false
          });
        },
        message: (_p = translations.PaymentCancelled) === null || _p === void 0 ? void 0 : _p.replace("{0:M/d/yyyy}", _this.state.paymentDeleted)
      }) : null, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 5,
          marginBottom: 20
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, {
        idTag1: 'lblNopendingPayments'
      }, "You do not currently have any pending payments.")))), /*#__PURE__*/React.createElement(Adbuttler, __assign({
        zoneId: "600391",
        zone: " Pending Payment Page "
      }, _this.props, {
        layout: layout,
        FallBack: layout.isEligible ? /*#__PURE__*/React.createElement(BannerView, {
          style: {
            marginBottom: 10
          }
        }, !layout.pennyWise ? layout.banksToAdd && layout.banksToAdd.length > 0 && layout.banksToAdd.find(function (s) {
          return s.isEDisbursementAccount;
        }) ? /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
          size: 14,
          value: translations.BorrowerEnrollForEdisb
        })) : /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
          size: 14,
          value: translations.BorrowerNotEnrollForEdisb
        })) : layout.banksToAdd && layout.banksToAdd.length > 0 && layout.banksToAdd.find(function (s) {
          return s.isEDisbursementAccount;
        }) ? /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
          size: 14,
          value: translations.PennyWiseBorrowerEnrollForEdisb
        })) : /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
          size: 14,
          value: translations.PennyWiseBorrowerNotEnrollForEdisb
        }))) : null
      })), ((_q = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _q === void 0 ? void 0 : _q.canMakePayment) ? /*#__PURE__*/React.createElement(View, {
        style: {
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 10,
          paddingHorizontal: 10,
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        nativeID: "btnMakePaymentOnline",
        idTag1: 'lblMakePaymentOnline',
        idTag7: 'lblMakePaymentOnline',
        style: {
          width: matches.small ? "100%" : "40%"
        },
        mode: "contained",
        onPress: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: '/Payment'
            }
          }, _this.props));
        }
      }, translations.MakePaymentOnline)) : null, !((_r = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _r === void 0 ? void 0 : _r.helocFlag) && (tableDataListHeloc === null || tableDataListHeloc === void 0 ? void 0 : tableDataListHeloc.length) > 0 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacTable, {
        style: {
          marginBottom: 20,
          backgroundColor: "#FFF",
          borderRadius: 10,
          shadowColor: "rgba(0,0,0, .08)",
          shadowOffset: {
            height: 4,
            width: 2
          },
          shadowOpacity: 1,
          shadowRadius: 12
        },
        borderStyle: {
          borderColor: "#EFEFEF"
        }
      }, !matches.small ? /*#__PURE__*/React.createElement(PnmacRow, {
        noBorder: true,
        flexArr: [1, 1, 1, 1, 1, 1, 1, 1],
        data: tableHeadListHeloc,
        style: {
          padding: matches.small ? 0 : 10,
          paddingLeft: matches.small ? 5 : 10,
          backgroundColor: "#EFEFEF",
          height: "auto",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10
        },
        textStyle: __assign(__assign({}, textStyle.formBody), {
          padding: matches.small ? 5 : 0,
          paddingRight: matches.small ? 5 : 10,
          fontSize: matches.small ? 10 : 14
        })
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), tableDataListHeloc.map(function (rowData, index) {
        return matches.small ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Transaction, {
          topLeftRadius: 10,
          topRightRadius: 10,
          botLeftRadius: index === tableDataListHeloc.length - 1 ? 10 : 0,
          botRightRadius: index === tableDataListHeloc.length - 1 ? 10 : 0,
          locale: layout === null || layout === void 0 ? void 0 : layout.language,
          key: index,
          transaction: lookBack[index],
          onTransactionPress: function () {
            return _this.setState({
              breakDownOpen: true,
              selectedIndex: index
            });
          },
          translations: translations
        })) : /*#__PURE__*/React.createElement(PnmacRow, {
          noBorder: true,
          flexArr: [1, 1, 1, 1, 1, 1, 1, 1],
          data: rowData,
          style: {
            padding: matches.small ? 0 : 10,
            paddingLeft: matches.small ? 5 : 10,
            backgroundColor: index % 2 === 0 ? "#FFF" : "#EFEFEF",
            borderBottomLeftRadius: index === (tableDataListHeloc === null || tableDataListHeloc === void 0 ? void 0 : tableDataListHeloc.length) - 1 ? 10 : 0,
            borderBottomRightRadius: index === (tableDataListHeloc === null || tableDataListHeloc === void 0 ? void 0 : tableDataListHeloc.length) - 1 ? 10 : 0
          },
          textStyle: __assign(__assign({}, textStyle.formBody), {
            padding: matches.small ? 5 : 0,
            fontSize: matches.small ? 10 : 14
          }),
          key: "".concat(rowData[0] + index)
        });
      }))) : null, Platform.OS !== 'web' && /*#__PURE__*/React.createElement(View, {
        style: {
          height: 100
        }
      }));
    });
  };
  return PaymentPending;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(PaymentPending, function (props) {
  var _a, _b;
  return (_b = (_a = props.translations) === null || _a === void 0 ? void 0 : _a.PendingPaymentPageTitle) !== null && _b !== void 0 ? _b : '';
}));